import React, { useState } from "react";
import { Modal, Box, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Button } from "@mui/material";
import { svCreateMaintenance } from "../../../services/expenses/maintenance.service";
import SwalUI from "../../../components/ui/swal-ui/swal-ui";
import CancelIcon from "@mui/icons-material/Cancel";
import "./FormAddmodal.scss";

const addDataDefault = {
  titlename: " ",
  repairbyname: " ",
  daterepair: " ",
  expenses: " ",
};

function FormAddModal({ openshop, handleCloseShop, setRefreshData }) {
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [addData, setAddData] = useState(addDataDefault);
  const [isError, setIsError] = useState({
    titlename: false,
    repairbyname: false,
    daterepair: false,
    expenses: false,
  });

  const handleStartDateChange = (date) => {
    console.log(moment(date));
    setAddData((prevState) => ({
      ...prevState,
      daterepair: moment(date),
    }));
  };

  const addValidators = () => {
    let isValid = true;
    let error = {
      ...isError,
      titlename: addData.titlename.trim().length < 1,
      repairbyname: addData.repairbyname.trim().length < 1,
      daterepair: addData.daterepair.toString().trim().length < 1,
      expenses: addData.expenses.trim().length < 1,
    };
    setIsError(() => error);

    const hasError = Object.values(error).find((err) => err === true);
    if (hasError) isValid = false;
    if (isValid) {
      const formData = new FormData();
      formData.append("title_name", addData.titlename);
      formData.append("name_repair_by", addData.repairbyname);
      formData.append(
        "date_repair",
        moment(addData.daterepair).format("DD/MM/YYYY")
      );
      formData.append("expenses", addData.expenses);

     
      svCreateMaintenance(formData).then((res) => {
        console.log(res);
        if (res.status === 200) {
          setRefreshData((prev) => prev + 1);
          handleCloseShop(false);
          SwalUI({
            status: res.data.status,
            // //description: res.data.description
          });
        }
      });
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Modal
        open={openshop}
        onClose={() => {
          handleCloseShop(false);
        }}
      >
        <Box
          className="width-modal"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",

            bgcolor: "white",
            borderRadius: "10px",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
            p: 4,
          }}
        >
          <div className="box-modal-add">
            <div className="justifu-CancelIcon">
              <p
                style={{
                  fontSize: "1.75rem",
                  fontWeight: 500,
                  alignItems: "center",
                }}
              >
                ค่าซ่อม / บำรุงรักษา
              </p>
              <button
                onClick={() => {
                  handleCloseShop(false);
                }}
              >
                <CancelIcon className="CancelIcon" />
              </button>
            </div>

            <div className="main-modal">
              <div className="box-modal-1">
                <div className="box-section">
                  <p
                    style={{
                      fontWeight: 500,
                      fontSize: "16px",
                      marginBottom: "5px",
                    }}
                  >
                    หัวข้อ
                  </p>
                  <TextField
                    id="outlined-basic"
                    size="small"
                    // label="หัวข้อ"
                    variant="outlined"
                    style={{ width: "100%" }}
                    value={addData.titlename}
                    error={isError.titlename}
                    onChange={(e) =>
                      setAddData((prevState) => {
                        return { ...prevState, titlename: e.target.value };
                      })
                    }
                  />
                </div>
                <div className="box-maintenance">
                  <p
                    style={{
                      fontWeight: 500,
                      fontSize: "16px",
                      marginBottom: "5px",
                    }}
                  >
                    วันเบิกซ่อม/บำรุง
                  </p>

                  <DatePicker
                    // label="ปี"
                    value={addData.daterepair}
                    inputFormat="DD/MM/YYYY"
                    onChange={handleStartDateChange}
                    sx={{ width: "33.33%" }}
                    error={isError.daterepair}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{ width: "100%" }}
                        size="small"
                        inputProps={{
                          ...params.inputProps,
                          readOnly: true,
                        }}
                        error={isError.daterepair}
                        required
                      />
                    )}
                  />
                </div>
              </div>
              <div className="box-modal-2">
                <div className="box-name-person">
                  <p
                    style={{
                      fontWeight: 500,
                      fontSize: "16px",
                      marginBottom: "5px",
                    }}
                  >
                    ชื่อผู้แจ้งซ่อม/บำรุง
                  </p>
                  <TextField
                    id="outlined-basic"
                    size="small"
                    // label="หัวข้อ"
                    variant="outlined"
                    style={{ width: "100%" }}
                    value={addData.repairbyname}
                    error={isError.repairbyname}
                    onChange={(e) =>
                      setAddData((prevState) => {
                        return { ...prevState, repairbyname: e.target.value };
                      })
                    }
                  />
                </div>
                <div className="box-total-expenses">
                  <p
                    style={{
                      fontWeight: 500,
                      fontSize: "16px",
                      marginBottom: "5px",
                    }}
                  >
                    ยอดค่าใช้จ่าย
                  </p>
                  <TextField
                    id="outlined-basic"
                    size="small"
                    // label="หัวข้อ"
                    InputProps={{
                      inputProps: {
                        pattern: "[0-9]", // Regular expression allowing only numbers
                      },
                    }}
                    onInput={(event) => {
                      const { value } = event.target;
                      const newValue = value.replace(/[^0-9]/g, ""); // Replace non-numeric characters with empty string
                      event.target.value = newValue; // Set the new value
                    }}
                    variant="outlined"
                    style={{ width: "100%" }}
                    value={addData.expenses}
                    error={isError.expenses}
                    onChange={(e) =>
                      setAddData((prevState) => {
                        return { ...prevState, expenses: e.target.value };
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="Button-save">
            <Button
              variant="contained"
              size="small"
              style={{
                fontSize: "14px",
                background: "#6C5DD3",
                color: "white",
                height: "39px",
                paddingLeft: "1.5rem",
                paddingRight: "1.5rem",
              }}
              className="button-h"
              onClick={addValidators}
            >
              บันทึก
            </Button>
          </div>
        </Box>
      </Modal>
    </LocalizationProvider>
  );
}

export default FormAddModal;
